import React, { useEffect, useState } from 'react';
import { parseEulaMarkdown } from './parseEulaMarkdown';
import './EulaGate.css';

// Fetches and renders the EULA markdown (public/eula.md). Shared by the forced
// EulaGate and the read-only viewer on the account-creation page so the parsing
// and document styling live in one place.
const EulaDocument = () => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetch(`${process.env.PUBLIC_URL || ''}/eula.md`)
      .then((res) => res.text())
      .then((text) => {
        if (cancelled) return;
        if (/^\s*<(!doctype|html)/i.test(text)) {
          throw new Error('eula.md fetch returned HTML instead of markdown');
        }
        setContent(parseEulaMarkdown(text));
      })
      .catch(() => {
        if (!cancelled) {
          setContent([
            <p key="error">
              Unable to load the End User License Agreement. Please check your connection and refresh, or contact support@sunlessinc.com.
            </p>,
          ]);
        }
      });
    return () => { cancelled = true; };
  }, []);

  return <div className="eula-document">{content || <p>Loading…</p>}</div>;
};

export default EulaDocument;
